document.addEventListener('DOMContentLoaded', function(){
  const btn = document.querySelector('.mobile-burger-btn');
  const drawer = document.getElementById('mobile-burger-drawer');
  const backdrop = drawer?.querySelector('.mobile-burger-backdrop');
  const closeBtn = drawer?.querySelector('.mobile-burger-close');

  if (!btn || !drawer) return; // Elemanlar yoksa çalıştırma

  function openMenu() {
    drawer.classList.add('open');
    backdrop?.classList.add('show');
  }

  function closeMenu() {
    drawer.classList.remove('open');
    backdrop?.classList.remove('show');
  }

  btn.addEventListener('click', openMenu);
  closeBtn?.addEventListener('click', closeMenu);
  backdrop?.addEventListener('click', closeMenu);
});


